<!--suppress ALL -->
<template>
    <div class="notif-upload-wrapper" :class="position">
        <div class="head-sec" :style="style">
            <p>Mengupload {{notificationUploads.length}} file</p>
            <div class="btn-wrp">
                <a @click="onToggleNotifUpload" class="button is-transparent">
                    <i class="fas fa-chevron-down"></i>
                </a>
                <a class="button is-transparent">
                    <i class="fas fa-times"></i>
                </a>
            </div>
        </div>
        <upload-progress v-for="(uploader, index) in notificationUploads"
                         :key="`notif-${index}`" :uploader="uploader"/>
    </div>
</template>

<script lang="ts">
	import {Component, Vue, Prop} from "annotation";

	@Component
	export default class NotificationUploadWrapper extends Vue {

		@Prop({default: 'bottom-right'})
		public position: string;

		public get notificationUploads() {
			if (Array.isArray(this.$root.notificationUploads)) {
				return this.$root.notificationUploads;
			}

			return [];
		}

		public get style() {
			if ((this.notificationUploads || []).length === 0) {
				return {
					display: 'none'
				};
			}

			return null;
		}

		public onToggleNotifUpload() {
			if (typeof this.$root.onToggleNotifUpload === 'function') {
				this.$root.onToggleNotifUpload();
			}
		}
	}
</script>

<style lang="scss" scoped>
    @import "../../style/variables_function";

    .notif-upload-wrapper {
        position: fixed;
        margin: 0 auto;
        z-index: 10000;
        width: 350px;
        @include b_sh_def;
        .head-sec {
            @include fl_row;
            background-color: $color-dark;
            padding: .5rem .75rem;
            align-items: center;
            p, a, i {
                color: white !important;
            }
            > p {
                flex: 1;
                font-size: .9rem;
                margin-bottom: 0;
            }
            > .btn-wrp {
                margin-left: 1rem;
            }
        }

        &.bottom-right {
            bottom: 15px;
            right: 15px;
        }

        &.top-right {
            bottom: 15px;
            right: 15px;
        }

        &.top-left {
            top: 15px;
            left: 15px;
        }

        &.bottom-left {
            bottom: 15px;
            left: 15px;
        }
    }
</style>
